import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    delete: string;
    duplicateProject: string;
    eject: string;
    linkDisabled: string;
    markActive: string;
    markInactive: string;
    menuTitle: string;
    mount: string;
    notifications: string;
    projectSettings: string;
    workfrontLink: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Menu item label to delete a project */
            delete: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ContextMenu.delete?c=7nzkz7owpk0x", defaultMessage: "Delete" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu item label to duplicate a project */
            duplicateProject: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ContextMenu.duplicateProject?c=346wnqj4f9ban", defaultMessage: "Duplicate Project" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu item label to eject a project mounted by the Frame.io Drive app */
            eject: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ContextMenu.eject?c=91rpnzce25e5", defaultMessage: "Eject" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Tooltip text when Workfront link is unavailable */
            linkDisabled: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ContextMenu.linkDisabled?c=3a06zzfzttonv", defaultMessage: "Link currently unavailable" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu item label to mark project active */
            markActive: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ContextMenu.markActive?c=1onj2x0360y5w", defaultMessage: "Mark Active" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu item label to mark project inactive */
            markInactive: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ContextMenu.markInactive?c=g8933be523v9", defaultMessage: "Mark Inactive" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu group label for project actions */
            menuTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ContextMenu.menuTitle?c=1y2semxo3c9fl", defaultMessage: "Project" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu item label to mount a project with the Frame.io Drive app */
            mount: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ContextMenu.mount?c=117glbwy9br38", defaultMessage: "Mount Project" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu item label for project notifications */
            notifications: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ContextMenu.notifications?c=1bmhy5j8pv1g6", defaultMessage: "Notifications" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu item label to open project settings */
            projectSettings: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ContextMenu.projectSettings?c=2okd1owibl5lb", defaultMessage: "Project Settings" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu item label to open in Workfront */
            workfrontLink: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ContextMenu.workfrontLink?c=3ueo5jgcl1qa1", defaultMessage: "Open in Workfront" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
